export default {"src":"/_next/static/media/CarValueTrackerActive.0a2df703.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};